// Bekanntes App-Universum im Admin — gespiegelt von Backend `KNOWN_APP_IDS`
// (curalearn-backend/src/lib/appTenant.ts). Bei einer neuen Lern-App hier UND
// im Backend ergänzen. Das Label ist die menschenlesbare Anzeige im Picker.
//
// `scheme` ist das URL-Schema der jeweiligen App, gespiegelt von
// `apps/<app>/brand.json` → `appConfig.tenant.scheme` (und identisch mit dem
// `expo.scheme` in `apps/<app>/app.json`). Es trägt jeden Deep-Link, den der
// Admin baut: App.tsx setzt die Linking-Prefixes daraus, und `parseDeepLink`
// zieht denselben Wert für den Push-Pfad. Ein Link mit fremdem Schema wird auf
// dem Gerät STILL verworfen — deshalb steht der Wert hier und wird nicht in den
// Editoren getippt.
export const KNOWN_APPS = [
  { id: 'currivium', label: 'Currivium HP', scheme: 'curalearn' },
  { id: 'psychotherapie', label: 'Currivium HPP', scheme: 'currivium-hpp' },
] as const;

export type AppId = (typeof KNOWN_APPS)[number]['id'];

export const DEFAULT_APP_ID: AppId = 'currivium';

/** Picker-Sentinel für die app-übergreifende Sicht ("Alle Apps"). */
export const ALL_APPS = 'all' as const;

/** Wert des globalen App-Pickers: eine konkrete App oder "Alle Apps". */
export type AppContextValue = AppId | typeof ALL_APPS;

/** Menschenlesbares Label einer App-ID; fällt auf die rohe ID zurück, falls unbekannt. */
export function appLabel(id: string): string {
  return KNOWN_APPS.find((a) => a.id === id)?.label ?? id;
}

/**
 * URL-Schema einer App-ID (ohne `://`).
 *
 * Fällt auf das Schema der Default-App zurück, falls die ID unbekannt ist — die
 * Editoren bekommen ihre App aus dem Picker, der bereits auf `DEFAULT_APP_ID`
 * normalisiert (`ALL_APPS` erreicht sie nie), also ist das derselbe Fallback wie
 * überall sonst im Admin und nie ein erfundenes Schema.
 */
export function appScheme(id: string): string {
  const known = KNOWN_APPS.find((a) => a.id === id);
  return known?.scheme ?? KNOWN_APPS.find((a) => a.id === DEFAULT_APP_ID)!.scheme;
}
